import { FaceLivenessDetectorCore } from '@aws-amplify/ui-react-liveness';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';

const REGION = (import.meta.env.VITE_AWS_REGION as string) ?? 'us-east-1';
const IDENTITY_POOL_ID = import.meta.env.VITE_IDENTITY_POOL_ID as string;

const credentialProvider = fromCognitoIdentityPool({
  clientConfig: { region: REGION },
  identityPoolId: IDENTITY_POOL_ID,
});

interface Props {
  sessionId: string;
  onComplete: () => void;
  onError: (error: Error) => void;
}

export default function LivenessWidget({ sessionId, onComplete, onError }: Props) {
  return (
    <FaceLivenessDetectorCore
      sessionId={sessionId}
      region={REGION}
      onAnalysisComplete={async () => onComplete()}
      onError={(err) => {
        console.error('FaceLivenessDetector error:', err.state, err.error);
        onError(new Error(`${err.state}: ${err.error?.message ?? 'Unknown error'}`));
      }}
      config={{
        credentialProvider: async () => {
          const creds = await credentialProvider();
          return {
            accessKeyId: creds.accessKeyId,
            secretAccessKey: creds.secretAccessKey,
            sessionToken: creds.sessionToken,
            expiration: creds.expiration,
          };
        },
      }}
      displayText={{
        hintCenterFaceText: 'Position your face in the oval',
        hintTooFarText: 'Move a bit closer',
        hintTooCloseText: 'Move back slightly',
        hintMoveFaceFrontOfCameraText: 'Look directly at the camera',
        hintHoldFaceForFreshnessText: 'Hold steady',
        hintConnectingText: 'Connecting…',
        hintVerifyingText: 'Verifying…',
        hintCheckCompleteText: 'Check complete',
        recordingIndicatorText: 'REC',
        photosensitivyWarningBodyText:
          'This check uses flashing lights. Stop if you experience discomfort.',
        photosensitivyWarningHeadingText: 'Photosensitivity warning',
        photosensitivyWarningInfoText: 'A small percentage of people may be affected.',
        photosensitivyWarningLabelText: 'Photosensitivity warning',
        retryCameraPermissionsText: 'Retry',
        startScreenBeginCheckText: 'Begin check',
      }}
    />
  );
}
